// W13 (E9): the optional free-text 'Reference' of a create form (reference_id: a customer PO number, a supplier invoice number ...). Max 128 characters; blank = none.
// The server's REFERENCE_ID_INVALID refusal is mapped to a plain EN/FR sentence by refusalOf (shell/drawer/refusal.mjs).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from './Input';

export const REFERENCE_MAX = 128;
export default function ReferenceField({ value, onChange, className = 'field', id = 'ref-field' }) {
  const { t } = useTranslation('common');
  return (
    <div className={className}>
      <label htmlFor={id}>{t('ref.label')}</label>
      <TextInput id={id} type="text" maxLength={REFERENCE_MAX} value={value || ''} title={t('ref.hint')} placeholder={t('ref.hint')} data-testid="reference-field" onChange={e => onChange && onChange(e.target.value)} />
    </div>
  );
}
